import { useState } from 'react';
import { useTemplate } from '../../../../../features/template/TemplateProvider';
import useApi from '../../../../../hook/useApi';
import { ButtonCancel, ButtonPrimary } from '../../../../../utils/Button';
import FocusControl from '../../../../../utils/FocusControl';
import InputField, {
    addOption,
    SelectOption,
    TextareaField
} from '../../../../../utils/InputField';
import countryAr from '../../../../../utils/country.json';
import { useInvoiceInfo } from '../InvoiceInfoProvider';

function ModalUpdateInvoiceBillingInfo() {
    const { handleReload, invoiceInfo } = useInvoiceInfo();
    const { setMessage, closeModal } = useTemplate();
    const { put } = useApi();
    const data = invoiceInfo || {};
    const { firstName, lastName, organization, email, phone, address, country, state, city, zip } =
        data?.billingAddress || {};
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        InvoiceId: data?.invoice?.id || 0,
        InvoiceTitle: data?.invoiceTitle,
        FirstName: firstName || '',
        LastName: lastName || '',
        Organization: organization || '',
        Email: email || '',
        Phone: phone || '',
        Address: address || '',
        Country: country || '',
        State: state || '',
        City: city || '',
        Zip: zip || ''
    });

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name) {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    const handleSaveClick = (e) => {
        e?.preventDefault();
        setLoading(true);
        put(`/api/invoices/${formData?.InvoiceId}/update-billing-to-info`, formData)
            .then(({ error, message, referenceName }) => {
                if (error) {
                    setIsError(referenceName);
                    throw new Error(message);
                }
                closeModal();
                handleReload();
                setMessage({ type: 'success', text: message });
            })
            .catch((err) => {
                setMessage({ type: 'error', text: err?.message });
            })
            .finally(() => {
                setLoading(false);
            });
    };
    FocusControl(isError, setIsError, formData);
    return (
        <form onSubmit={handleSaveClick} className="flex flex-col gap-4">
            <InputField
                label="Organization"
                name="Organization"
                placeholder='e.g. "Google"'
                formData={formData}
                onChange={handleChange}
                required
            />
            <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                <InputField
                    label="First Name"
                    name="FirstName"
                    placeholder='e.g. "John"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
                <InputField
                    label="Last Name"
                    name="LastName"
                    placeholder='e.g. "Smith"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
            </div>
            <div className="flex flex-col sm:flex-row  justify-between items-center gap-4">
                <InputField
                    label="Email Address"
                    name="Email"
                    placeholder='e.g. mail@example.com"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
                <InputField
                    label="Phone Number"
                    name="Phone"
                    placeholder='e.g. "+1 541 754 3010"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
            </div>
            <TextareaField
                label="Address"
                name="Address"
                placeholder='e.g. "1234 Main St"'
                formData={formData}
                onChange={handleChange}
                className="h-16"
                required
            />
            <div className=" flex flex-row gap-x-4">
                <SelectOption
                    label="Country"
                    name="Country"
                    formData={formData}
                    onChange={handleChange}
                    options={countryAr?.map(({ name, code }) => addOption(code, name, code))}
                    required
                />
                <InputField
                    label="Province/State"
                    name="State"
                    placeholder='e.g. "California"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
            </div>
            <div className="h-16 flex flex-row gap-x-4">
                <InputField
                    label="City"
                    name="City"
                    placeholder='e.g. "San Francisco"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
                <InputField
                    label="ZIP"
                    name="Zip"
                    placeholder='e.g. "94107"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
            </div>
            <div className="flex justify-end">
                <div className="flex items-center gap-x-3">
                    <ButtonCancel title="Cancel" onClick={closeModal} />
                    <ButtonPrimary title="Save" btnType="submit" loading={loading} />
                </div>
            </div>
        </form>
    );
}

export default ModalUpdateInvoiceBillingInfo;
